var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpyzieLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "118px",
    height: "24px",
    viewBox: "0 0 118 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo/\u9876\u90E8\u5BFC\u822Alogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo/\\u9876\\u90E8\\u5BFC\\u822Alogo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.102110429,22.1329562 L2.14431901,17.4823197 C2.75698465,17.8444148 3.60222364,18.1782163 4.68006133,18.4837341 C5.75789903,18.7892519 6.70524742,18.9420085 7.52213494,18.9420085 C8.42978774,18.9420085 9.15589908,18.755306 9.70049076,18.3818953 C10.2450824,18.0084847 10.5173742,17.5954761 10.5173742,17.1428571 C10.5173742,16.8486548 10.3188281,16.5601146 9.92173002,16.2772277 C9.52463192,15.9943409 8.88361175,15.5926476 7.99865027,15.0721358 L6.94350917,14.4611033 C5.40049942,13.5558653 4.1978775,12.8033976 3.33560735,12.2036775 C2.47333719,11.6039574 1.70184389,10.8288591 1.02110429,9.87835926 C0.340364693,8.92785946 -8.52651283e-14,7.85290557 -8.52651283e-14,6.65346535 C-8.52651283e-14,5.38613228 0.357382928,4.24894421 1.0721595,3.24186704 C1.78693608,2.23478987 2.79101193,1.44837624 4.08441716,0.882602546 C5.3778224,0.316828854 6.88677254,0.0339462518 8.61131285,0.0339462518 C9.79126148,0.0339462518 10.9995561,0.203675813 12.2362331,0.543140028 C13.47291,0.882604243 14.5337133,1.34653171 15.4186748,1.93493635 L13.5806871,6.11032532 C12.3780471,5.70296826 11.4533897,5.43140096 10.8066871,5.29561528 C10.1599845,5.15982959 9.45089134,5.09193777 8.67938647,5.09193777 C7.99864687,5.09193777 7.44839062,5.25035202 7.0286012,5.56718529 C6.60881178,5.88401856 6.39892022,6.2687389 6.39892022,6.72135785 C6.39892022,7.06082207 6.57477531,7.36067762 6.92649077,7.62093352 C7.27820623,7.88118942 7.86249895,8.2263062 8.67938647,8.6562942 L9.90471162,9.33521924 C11.3342648,10.1499334 12.5255412,10.9024011 13.4785766,11.592645 C14.4316121,12.2828889 15.2428146,13.0975908 15.9122085,14.0367751 C16.5816025,14.9759594 16.9162944,16.0339463 16.9162944,17.2107496 C16.9162944,18.5233446 16.5418932,19.6888209 15.7930797,20.7072136 C15.0442661,21.7256062 13.9721174,22.5289928 12.5766012,23.1173975 C11.181085,23.7058021 9.55300722,24 7.69231899,24 C6.48967903,24 5.14523849,23.8189551 3.65895704,23.45686 C2.17267559,23.0947648 0.987071905,22.6534679 0.102110429,22.1329562 Z",
    id: "Path",
    fill: "#91A3F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25,0.5 C34.8063492,0.5 38.5,4.19365081 38.5,8.75 C38.5,13.3063492 34.8063492,17 30.25,17 L25.5,17 L25.5,23.5 L19.5,23.5 L19.5,0.5 L30.25,0.5 Z M29.25,5.5 L25.5,5.5 L25.5,12 L29.25,12 C31.0449254,12 32.5,10.5449254 32.5,8.75 C32.5,6.95507456 31.0449254,5.5 29.25,5.5 Z",
    id: "Combined-Shape",
    fill: "#91A3F2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#91A3F2",
    points: "53 23.5 47 23.5 47 14.5 39.5 1.5 45.5 0.5 50 9 54.5 0.5 61 0.5 53 14.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8CDFB0",
    points: "79.5 18.5 79.5 23.5 62 23.5 62 18.5 73.5 5.5 63.5 5.5 63.5 0.5 80.5 0.5 80.5 5.5 68.5 18.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8CDFB0",
    points: "89 23.5 83 23.5 83 0.5 89 0.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8CDFB0",
    points: "107 23.5 92 23.5 92 0.5 107 0.5 107 5.5 98 5.5 98 9.5 106 9.5 106 14.5 98 14.5 98 18.5 107 18.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F07878",
    opacity: 0.649944196,
    x: 109,
    y: 1,
    width: 8,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#FFB463",
    opacity: 0.649944196,
    x: 109,
    y: 5,
    width: 6,
    height: 3,
    rx: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpyzieLogo);
export default __webpack_public_path__ + "static/media/spyzie_logo.8f5340271dc55daf35cafae95f002224.svg";
export { ForwardRef as ReactComponent };